import React from "react";
import { FiArrowLeft } from "react-icons/fi";
import "./index.scss";

const Header = ({ title, leftIcon, onLeftClick, rightContent }) => {
  return (
    <header className="app-header">
      <div className="header-left">
        {leftIcon && (
          <button className="icon-button" onClick={onLeftClick}>
            {leftIcon}
          </button>
        )}
      </div>

      <h1 className="header-title">{title}</h1>

      <div className="header-right">
        {rightContent || <div className="header-placeholder" />}
      </div>
    </header>
  );
};

export default Header;
